export default "__VITE_ASSET__u076CFun__"